<template>
  <div class="lg:col-auto">
    <ul class="navbar__options form-row flex-nowrap list-unstyled m-0 items-center justify-end">
      <!-- hamburger (for short) -->
      <li
        v-if="type === 'short'"
        class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0"
      >
        <VDropdown
          v-if="isSignedIn"
          theme="usermenu"
        >
          <router-link
            :to="{ name: 'customerProfilePath' }"
            class="btn btn-outline-primary p-2 xxl:px-3 border-0 rounded-pill"
            aria-label="Sign in"
            data-cy="profile"
          >
            <i
              v-if="getCurrentCustomer.inPlusClub"
              class="mi-mixit-plus icon-mixit-plus absolute"
            />
            <i class="mi-user-fill icon-20 sm:icon-24 sm:mr-1" />
            <span class="hidden sm:block">{{ getCurrentCustomer.firstName }}</span>
          </router-link>

          <template #popper>
            <TheNavbarLoggedInPopover />
          </template>
        </VDropdown>
        <button
          v-else
          class="btn  btn-primary p-2 xxl:px-3 border-0 rounded-pill"
          aria-label="Sign in"
          type="button"
          data-cy="open-signin"
          @click="openModal({ id: 'modal-sign-in' })"
        >
          <span class="hidden xxl:block">{{ t('log_in') }}</span>
          <i class="mi-user-fill icon-24 xxl:hidden" />
        </button>
      </li>
      <!-- login (dark) -->
      <li
        v-if="type === 'full'"
        class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 hidden sm:block"
      >
        <VDropdown
          v-if="isSignedIn"
          theme="usermenu"
        >
          <router-link
            :to="{ name: 'customerProfilePath' }"
            class="btn btn-outline-primary p-2 xxl:px-3 border-0 rounded-pill"
            aria-label="Sign in"
            data-cy="profile"
          >
            <i
              v-if="getCurrentCustomer.inPlusClub"
              class="mi-mixit-plus icon-mixit-plus absolute"
            />
            <i class="mi-user-fill icon-20 sm:icon-24 sm:mr-1" />
            <span class="hidden sm:block">{{ getCurrentCustomer.firstName }}</span>
          </router-link>

          <template #popper>
            <TheNavbarLoggedInPopover />
          </template>
        </VDropdown>
        <button
          v-else
          class="btn  btn-primary p-2 xxl:px-3 border-0 rounded-pill"
          aria-label="Sign in"
          type="button"
          data-cy="open-signin"
          @click="openModal({ id: 'modal-sign-in' })"
        >
          <span class="hidden xxl:block">{{ t('log_in') }}</span>
          <i class="mi-user icon-20 sm:icon-24 xxl:hidden" />
        </button>
      </li>
      <!-- login (light) -->
      <li
        v-if="type === 'full'"
        class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 sm:hidden"
      >
        <VDropdown
          v-if="isSignedIn"
          theme="usermenu"
        >
          <router-link
            :to="{ name: 'customerProfilePath' }"
            class="btn btn-primary p-2 border-0 rounded-pill"
            aria-label="Sign in"
            data-cy="profile"
          >
            <i
              v-if="getCurrentCustomer.inPlusClub"
              class="mi-mixit-plus icon-mixit-plus absolute"
            />
            <i class="mi-user icon-20 sm:icon-24" />
          </router-link>

          <template #popper>
            <TheNavbarLoggedInPopover />
          </template>
        </VDropdown>
        <button
          v-else
          class="btn btn-outline-primary p-1 border-0 rounded-pill"
          aria-label="Sign in"
          type="button"
          data-cy="open-signin"
          @click="openModal({ id: 'modal-sign-in' })"
        >
          <i class="mi-user icon-20 sm:icon-24" />
        </button>
      </li>
      <!-- search -->
      <li
        v-if="type === 'full'"
        class="search-btn col-auto px-0 ml-n1 sm:ml-1 lg:ml-0"
      >
        <button
          type="button"
          class="btn btn-outline-primary p-1 border-0 rounded-pill"
          aria-label="Search"
          data-toggle="modal"
          data-target="#modal-search"
          @click="openModal({ id: 'modal-id-search' })"
        >
          <i class="mi-search icon-20 sm:icon-24" />
        </button>
      </li>
      <!-- favourite -->
      <li class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 hidden lg:block">
        <router-link
          v-if="isSignedIn"
          :to="{ name: 'customerMixesPath' }"
          class="js-favourite btn btn-outline-primary p-2 border-0 rounded-pill"
          aria-label="Favorite mixes"
        >
          <i class="mi-heart icon-24" />
        </router-link>
        <router-link
          v-else
          :to="{ name: 'signInPath' }"
          class="js-favourite btn btn-outline-primary p-2 border-0 rounded-pill"
          aria-label="Favorite mixes"
        >
          <i class="mi-heart icon-24" />
        </router-link>
      </li>
      <!-- basket -->
      <li class="nav-cart col-auto px-0 ml-n1 sm:ml-1 lg:ml-0">
        <VDropdown
          theme="navCart"
          :disabled="isTouchDevice"
        >
          <router-link
            :to="{ name: 'cartsPath' }"
            class="js-basket btn btn-outline-primary p-1 lg:p-2 border-0 rounded-pill"
            aria-describedby="tooltip-delivery"
            aria-label="Cart"
            data-cy="navbar-cart"
          >
            <i class="mi-cart icon-20 sm:icon-24" />
            <span
              v-if="isCartNotEmpty"
              class="js-price hidden sm:block pl-1 sm:pl-2"
            >
              {{ getCartPrice }}
            </span>
            <span
              class="cart-quantity-badge mr-1 absolute bg-danger rounded-pill text-nowrap text-sm text-white leading-1"
            >
              <BaseOdometer :number="getTotalItemsInCart" />
            </span>
            <div
              v-if="isFreeTransportNotice"
              class="cart-delivery-progress absolute flex items-center"
            >
              <div class="badge relative text-white items-center justify-center">
                <i class="mi-delivery" />
              </div>
              <div
                class="progress-bar"
                :class="{ 'progress-bar-show': freeShippingProgress > 0 }"
              >
                <div
                  class="progress-percent"
                  :style="{ width: `${freeShippingProgress}%` }"
                />
              </div>
            </div>
          </router-link>
          <template #popper>
            <TheNavbarCartBox
              :amount="freeShippingPrice"
              :percent="freeShippingProgress"
            />
          </template>
        </VDropdown>
      </li>
      <!-- hamburger (for full) -->
      <li
        v-if="type === 'full'"
        class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 lg:hidden"
      >
        <button
          type="button"
          class="btn btn-outline-primary p-2 border-0 rounded-pill"
          aria-label="Open the main menu"
          @click="openModal({ id: 'modal-id-menu' })"
        >
          <i class="mi-bars icon-20 sm:icon-24 mi-lh-1" />
        </button>
      </li>
      <!-- language -->
      <li class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 hidden sm:block">
        <VDropdown theme="usermenu">
          <div v-if="type === 'full'">
            <a
              href="#"
              class="btn p-1 border-0 rounded-pill"
              aria-label="Language option"
            >
              <Component
                :is="getCurrentLocaleFlag(country)"
                width="34"
                height="34"
              />
            </a>
          </div>
          <template #popper>
            <ul class="list-unstyled m-0">
              <li
                v-for="language in LanguagesFlags"
                :key="language"
                class="col-auto px-0 ml-n1 sm:ml-1 lg:ml-0 hidden sm:block"
              >
                <a
                  v-if="language.shortcut !== country"
                  :href="language.link"
                  class="btn p-1 border-0 rounded-pill"
                  aria-label="Language option"
                >
                  <Component
                    :is="language.svg"
                    width="34"
                    height="34"
                  />
                </a>
              </li>
            </ul>
          </template>
        </VDropdown>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import TheNavbarCartBox from '@/components/menus/navbar/TheNavbarCartBox.vue'
import TheNavbarLoggedInPopover from '@/components/menus/navbar/TheNavbarLoggedInPopover.vue'
import { getCurrentLocaleFlag, LanguagesFlags } from '@/components/svg/flags/languagesFlags'
import BaseOdometer from '@/components/general/BaseOdometer.vue'
import { useAppStore } from '@/stores/AppStore'
import { useCartStore } from '@/stores/CartStore'
import { useModalStore } from '@/stores/ModalStore'
import { useCountry } from '@/mixins/useCountry'

defineProps({
  type: {
    type: String,
    default: 'full',
    validator(value) {
      return ['full', 'short'].includes(value)
    },
  },
})

const { t } = useI18n()
const country = useCountry()

const { openModal } = useModalStore()
const isTouchDevice = ref(false)

const appStore = useAppStore()
const { isSignedIn, getCurrentCustomer, isFreeTransportNotice } = storeToRefs(appStore)

const cartStore = useCartStore()
const { isCartNotEmpty, getTotalItemsInCart, getCartPrice } = storeToRefs(cartStore)

const freeShippingPrice = computed(() => {
  if (cartStore.getTotalItemsInCart > 0) {
    return cartStore.getCart?.priceUntilFreeTransport
  }
  return t('free_shipping')
})

const freeShippingProgress = computed(() => {
  return (
    (Number.parseInt(t('free_shipping')) - cartStore.getCart?.priceUntilFreeTransport) /
    (Number.parseInt(t('free_shipping')) / 100)
  )
})

if (window.matchMedia('(pointer: coarse)').matches) {
  isTouchDevice.value = true
}
</script>

<i18n>
  {
    "cs": {
    "free_shipping": "1499",
    "log_in": "Přihlásit se"
},
    "sk": {
    "free_shipping": "59",
    "log_in": "Prihlásiť sa"
},
    "pl": {
    "free_shipping": "199",
    "log_in": "Zaloguj się"
},
    "hu": {
    "free_shipping": "18990",
    "log_in": "Bejelentkezés"
},
    "de": {
    "free_shipping": "49",
    "log_in": "Anmelden"
},
    "at": {
    "free_shipping": "49",
    "log_in": "Anmelden"
},
    "ro": {
    "free_shipping": "199",
    "log_in": "Intră în cont"
},
    "fr": {
    "free_shipping": "1499",
    "log_in": "Se connecter"
},
    "it": {
    "free_shipping": "49",
    "log_in": "Accedi"
}
  }
</i18n>

<style lang="scss" scoped>
.nav-cart {
  min-width: 124px;
  @media screen and (max-width: 575px) {
    min-width: auto;
  }
}
.cart-quantity-badge {
  top: -5px;
  left: 18px;
  width: 20px;
  height: 20px;

  @include media-breakpoint-up(sm) {
    top: 0px;
    left: 24px;
  }
}

.cart-delivery-progress {
  left: 16px;
  bottom: -11px;
  width: 100%;
  .badge {
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    border-radius: 50rem;
    background-color: #22548c;
    position: relative;
    z-index: 4;
    display: flex;

    .v-popper {
      width: 100%;
    }
    i {
      font-size: 15px;
    }
  }
  .progress-bar {
    width: 66%;
    border-radius: 50rem;
    background-color: #4696ef;
    height: 8px;
    margin-left: -6px;
    overflow: hidden;
    opacity: 0;
    transform: translateX(-5px);
    transition: 0.5s;

    &-show {
      opacity: 1;
      transform: translateX(0px);
    }

    .progress-percent {
      background-color: #22548c;
      height: 100%;
      max-width: 100%;
      transition: 0.5s width;
    }
  }

  @media screen and (max-width: 1399px) {
    left: 16px;
    bottom: -1px;
  }

  @media screen and (max-width: 575px) {
    left: 0px;
    justify-content: center;
    .badge {
      display: none;
    }
    .progress-bar {
      width: 60%;
      height: 12px;
      margin-left: 0px;
    }
  }
}

.navbar--basket {
  .cart-delivery-progress {
    left: 17px;
    bottom: -2px;
  }
}

.icon-mixit-plus {
  width: 8px;
  height: 8px;
  left: 27px;
  top: 7px;
  font-size: 8px;

  @include media-breakpoint-up(sm) {
    left: 33px;
  }
}
</style>
